import React, { useState, useEffect } from "react";
import "./DULeadContent.css";
import Modal from "react-modal";
import { DULeadData } from "./DULeadContentData.jsx";
import AOS from 'aos'
import 'aos/dist/aos.css';

function DULeadContent() {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, [])
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };

  return (
    <>
      <div className="dulead-container">
        <div className="dulead-wrap">
          <span className="tabs-bg"></span>
          {DULeadData.map((item) => {
            let video = item.duleadVideo;
            return (
              <div className="dulead-row">
                <div
                  className="dulead-box"
                  onClick={() => handleOpenModal(video)}
                  data-aos="zoom-in-up"
                >
                  <img
                    src={item.duleadImage}
                    alt={item.duleadName + " profile pic"}
                    className="dulead-card-imgs"
                  />
                  <h3>{item.duleadName}</h3>
                  <p className="dulead-project">{item.duleadProject}</p>
                  <p className="dulead-market">{item.duleadMarket}</p>
                </div>
                <Modal
                  isOpen={showModal && activeModal === video}
                  onRequestClose={() => setShowModal(false)}
                  // contentLabel="login Modal"
                  style={{
                    overlay: {
                      backgroundColor: "rgba(0, 0, 0, 0.75)",
                    },
                  }}
                >
                  <iframe
                    id="kmsembed-1_z06m2jc5"
                    width="100%"
                    height="85%"
                    src={item.duleadVideo}
                    class="kmsembed"
                    allowfullscreen
                    webkitallowfullscreen
                    mozAllowFullScreen
                    allow="autoplay *; fullscreen *; encrypted-media *"
                    referrerPolicy="no-referrer-when-downgrade"
                    frameborder="0"
                    title="Testimonial"
                  ></iframe>
                  <h3>{item.duleadName}</h3>
                  <p className="modal-project">{item.duleadProject}</p>
                  <p className="modal-market">{item.duleadMarket}</p>
                  <button
                    className="close closing-btn"
                    onClick={handleCloseModal}
                  >
                    <span>x</span> CLOSE
                  </button>
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default DULeadContent;
